import React, { Component } from 'react';

export default class NewCategoryContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">New Category</h3>
        </div>

        <div className="categoryTypes">
          <div></div>
        </div>
      </div>
    );
  }
}
